export default __webpack_public_path__ + "static/ambirewallet-cba4bfc7e00dfbd51135dfeb7cf73b28.png";